import { FunctionComponent } from 'react';
import TextCell from '../TextCell/TextCell';
import { HStack } from '@montel/montelpro-shared-components-v2';
import { ProductIcon } from 'components/common/Product/ProductIcon/ProductIcon';
import { ProductRegistration } from 'domain/product/interfaces';
import { ProductName } from 'domain/product/enums';
import { getProductConfig } from 'domain/product/productMap';

interface ProductRegistrationCellProps {
	productRegistration: ProductRegistration;
}

export const ProductRegistrationCell: FunctionComponent<
	ProductRegistrationCellProps
> = ({ productRegistration }) => {
	const config = getProductConfig(productRegistration.productId);

	switch (config?.name) {
		case ProductName.NewsPage:
		case ProductName.EnAppSys:
		case ProductName.Alerts:
		default:
			return (
				<HStack align="center" gap="sm">
					<ProductIcon
						productId={productRegistration.productId}
						withTooltip={false}
					/>
					<TextCell text={config?.name ?? 'N/A'} />
				</HStack>
			);
	}
};
